module.exports = __webpack_public_path__ + "img/rank-left.7c4a6c41.png";